import React, { useState } from "react";
import { useSelector } from "react-redux";
import EditBranchesCommonComponent from "views/pages/manage/common/branchesCommonComponent/EditBranchesCommonComponent";
import APopover from "views/pages/manage/common/pop-hover/APophover";
import DisplayRegion from "views/pages/manage/edpOps/batch-serach/DisplayRegion";

const LeftSideFilter = ({ filterForm,  searchHandler, setFilterForm, businessAreaMap,
  setBusinessAreaMap }) => {

  const studentDetails = useSelector((state) => state.studentSearch);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleSearch = (data) => {
    const reg = data.region.map(i => i.value);
    const bus = data.businessArea.map(i => i.value);
    const newFilter={...filterForm, region : reg, businessArea: bus}

    setBusinessAreaMap({...data})
    setFilterForm({...filterForm,businessArea : data.businessArea, region : data.region});
    searchHandler(newFilter)
  }

  const getList = () => {

  }

  const getLabel = (count) => count > 1 ? "Payment Collection Listing" : "Payment Collection Listing";
  return (
    <div style={{ position: "relative", minWidth: "4rem" }}>
      <h4 style={{ color: "black" }}> {getLabel(studentDetails && studentDetails.rowCount)} {`(${studentDetails && studentDetails.rowCount})`}</h4>
      <div>

        <><DisplayRegion
          items={(
            businessAreaMap.region
          )}
          type="Regions"
        />
          <span>
            |
            <DisplayRegion
              items={(businessAreaMap.businessArea)}
              type="Business Areas"
            />
          </span>
        </>


        {/* <DisplayRegion items={filterForm.businessArea} type="Business Areas" /> */}
        <span
          onClick={handleClick}
          aria-describedby={"demo"}
          style={{
            color: " #00B0F5",
            cursor: "pointer",
          }}
        >
          View/Edit
        </span>
      </div>

      <APopover handleClose={handleClose} id="info-batch" anchorEl={anchorEl}>
        <EditBranchesCommonComponent
          title={'Branch Details'}
          closeForm= { handleClose }
          updateHandler = {handleSearch}
          businessAreas = {businessAreaMap.businessArea}
          regions = {businessAreaMap.region}
        />
      </APopover>
    </div>
  );
};

export default LeftSideFilter;
